import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import arTranslations from "./locales/ar/translations";
import enTranslations from "./locales/en/translations";

export const supportedLanguages = ["en", "ar"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const rtlLanguages: SupportedLanguage[] = ["ar"];

const resources = {
  en: {
    translations: enTranslations,
  },
  ar: {
    translations: arTranslations,
  },
};

export const createUIi18nInstance = () => {
  const uiI18n = i18n.createInstance();

  uiI18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    defaultNS: "translations",
    ns: ["translations"],
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

  return uiI18n;
};

export const isRTL = (language: SupportedLanguage): boolean => {
  return rtlLanguages.includes(language);
};
